// A custody field on the phone is a thumb's target: 44 px tall, like every
// button here (Screens' round 2, 23 Oct 2026 — the inputs and selects stood
// at 40–42 px). From lg the console keeps its own density (styles.css).
export const FIELD = 'input min-h-[44px] lg:min-h-0 text-field lg:text-body';
export const SELECT = 'select min-h-[44px] lg:min-h-0 text-field lg:text-body';
